import React from 'react';
import { LayersControl, TileLayer } from 'react-leaflet';

// Único lugar que sabe de proveedores de tiles. Si el día de mañana hace
// falta imagen más actualizada (ej. migrar a Google Maps JS API con cuenta
// propia y facturación), el cambio queda contenido acá — el resto de los
// componentes de mapa (marcadores, popups) no dependen del proveedor.
const BaseTileLayer: React.FC = () => (
  <LayersControl position="topright">
    <LayersControl.BaseLayer checked name="Satelital">
      <TileLayer
        attribution="Tiles &copy; Esri — Source: Esri, Maxar, Earthstar Geographics"
        url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
        maxZoom={19}
      />
    </LayersControl.BaseLayer>
    <LayersControl.BaseLayer name="Calle">
      <TileLayer
        attribution="&copy; OpenStreetMap contributors"
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        maxZoom={19}
      />
    </LayersControl.BaseLayer>
  </LayersControl>
);

export default BaseTileLayer;
